import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { useAnalysisStore } from '../../stores/analysisStore';
import { useGraphStore } from '../../stores/graphStore';
import { useNavigationStore } from '../../stores/navigationStore';
import ChamberGraph from '../ChamberGraph';
import GraphOptionsDialog from '../dialogs/GraphOptionsDialog';

const ChamberGrid = ({ tabId }) => {
  const tab = useAnalysisStore((state) => state.openFiles[tabId]);
  const activeGraphId = tab?.activeGraphId ?? null;
  const setActiveChamber = useAnalysisStore((state) => state.setActiveChamber);
  const setActiveGraph = useAnalysisStore((state) => state.setActiveGraph);
  const setActivePlot = useNavigationStore((state) => state.setActivePlot);
  const isLoading = useAnalysisStore((state) => state.isLoading);
  const graphs = useGraphStore((state) => state.tabGraphs[tabId]) || [];

  // Dialog hosted at grid level — survives ChamberGraph unmount when the
  // user deletes a graph through the dialog and clicks Apply.
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogGraphId, setDialogGraphId] = useState(null);

  const handleActivate = useCallback(
    (graph) => {
      if (graph.kind === 'chamber') {
        setActiveChamber(tabId, graph.chamberIndex);
        setActivePlot(tabId, graph.chamberIndex);
      } else {
        setActiveGraph(tabId, graph.id);
      }
    },
    [tabId, setActiveChamber, setActiveGraph, setActivePlot],
  );

  const handleOpenSettings = useCallback((graphId) => {
    setDialogGraphId(graphId);
    setDialogOpen(true);
  }, []);

  if (!tab) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography variant="body2" sx={{ color: '#7d8d97' }}>
          No file data loaded
        </Typography>
      </Box>
    );
  }

  if (isLoading && graphs.length === 0) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <CircularProgress size={28} sx={{ color: '#394b57' }} />
      </Box>
    );
  }

  if (graphs.length === 0) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography variant="body2" sx={{ color: '#7d8d97' }}>
          No chamber data available
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        // padding: '8px',
        height: '100%',
        overflow: 'auto',
      }}
    >
      {graphs.map((graph) => (
        <Box key={`${tabId}-${graph.id}`} sx={{ width: '100%', height: '400px', flexShrink: 0 }}>
          <ChamberGraph
            tabId={tabId}
            graphId={graph.id}
            isActive={activeGraphId === graph.id}
            onActivate={() => handleActivate(graph)}
            onOpenSettings={handleOpenSettings}
          />
        </Box>
      ))}

      <GraphOptionsDialog
        open={dialogOpen}
        tabId={tabId}
        initialGraphId={dialogGraphId}
        onClose={() => setDialogOpen(false)}
      />
    </Box>
  );
};

export default ChamberGrid;
